import { getTableColumn, TableColumn } from '@shared/UI';
import { IReserveComputationDate } from './ReserveComputationTableProvider';

export function getReserveComputationTableColumns(): TableColumn<IReserveComputationDate>[] {
    return [
        getTableColumn({
            dataField: 'date',
            firstColumn: true,
            flex: 1,
        }),
    ];
}
